import React, { useEffect, useState } from "react";
import Table, { LeadtimeCell, SelectColumnFilter, StatusPill } from "./Table"; // new

function TableData() {
  const data = [
    {
      id: "1",
      code: "123-xzy",
      name: "2 X 4M Stagging",
      version: "1.2",
    },
    {
      id: "2",
      code: "123-xzy",
      name: "Electric Foot",
      version: "1.2",
    },
    {
      id: "3",
      code: "123-xzy",
      name: "5 axis CNC",
      version: "1.2",
    },
    {
      id: "4",
      code: "123-xzy",
      name: "Massage Chair",
      version: "1.2",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Item Code",
        accessor: "code",
      },
      {
        Header: "Item Name",
        accessor: "name",
      },

      {
        Header: "Lead Time",
        accessor: "time",
        Cell: LeadtimeCell,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: (value) => (
          <div className="flex flex-wrap">
            <div className="px-6 text-gray-900 py-4 font-medium text-left">
              Issue{" "}
              <div class="w-full bg-gray-200 rounded-full h-2.5 ">
                <div
                  class="bg-blue-600 h-2.5 rounded-full"
                  style={{ width: "45%" }}
                ></div>
              </div>
            </div>
            <div className="mt-5">
            <svg
            width="30"
            height="26"
            viewBox="0 0 30 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.1465 0L27.9661 19.5H2.32695L15.1465 0Z"
              fill="#1F78B4"
            />
            <path
              d="M16.2471 7.35L16.0071 14.595H14.2371L13.9821 7.35H16.2471ZM15.1671 18.105C14.7871 18.105 14.4721 17.99 14.2221 17.76C13.9821 17.52 13.8621 17.225 13.8621 16.875C13.8621 16.525 13.9821 16.235 14.2221 16.005C14.4721 15.765 14.7871 15.645 15.1671 15.645C15.5371 15.645 15.8421 15.765 16.0821 16.005C16.3221 16.235 16.4421 16.525 16.4421 16.875C16.4421 17.225 16.3221 17.52 16.0821 17.76C15.8421 17.99 15.5371 18.105 15.1671 18.105Z"
              fill="white"
            />
          </svg>
            </div>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <Table
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableData;
